import { BaseChart } from 'src/app/core/data/model';

export class LineChart extends BaseChart {
  constructor(
    public override dataSet: number[],
    public override label?: string,
    public override backgroundColor?: string[] | string,
    public override borderColor?: string,
    public dataSetPointBackgroundColor?: string,
    public dataSetPointBorderColor?: string,
    public dataSetPointHoverBackgroundColor?: string,
    public dataSetPointHoverBorderColor?: string
  ) {
    super(dataSet, label, backgroundColor, borderColor);
    this.dataSetPointBackgroundColor = dataSetPointBackgroundColor;
    this.dataSetPointBorderColor = dataSetPointBorderColor;
    this.dataSetPointHoverBackgroundColor = dataSetPointHoverBackgroundColor;
    this.dataSetPointHoverBorderColor = dataSetPointHoverBorderColor;
  }
}
